var map = {
	"./videos/all-star/hero-vid_cn.mp4": 1453,
	"./videos/all-star/hero-vid_en.mp4": 1454,
	"./videos/alter-ego/alter-ego_16-9.mp4": 1455,
	"./videos/alter-ego/alter-ego_16-9_poster.jpg": 1456,
	"./videos/alter-ego/alter-ego_3-4.mp4": 1457,
	"./videos/alter-ego/alter-ego_3-4_poster.jpg": 1458,
	"./videos/alter-ego/alter-ego_9-16.mp4": 1459,
	"./videos/alter-ego/alter-ego_9-16_poster.jpg": 1460,
	"./videos/alter-ego/brush-mask.png": 271,
	"./videos/alter-ego/stroke-dark.mp4": 1461,
	"./videos/alter-ego/stroke-long-compressed.mp4": 1462,
	"./videos/alter-ego/stroke-long.mp4": 1463,
	"./videos/artprize/launch-cn.mp4": 1464,
	"./videos/artprize/launch-en.mp4": 1465,
	"./videos/error/animation-video-nikko-poster.jpg": 1466,
	"./videos/error/animation-video-nikko.mp4": 1467,
	"./videos/home/home_cn.jpg": 1468,
	"./videos/home/home_cn.mp4": 1469,
	"./videos/home/home_en.jpg": 1470,
	"./videos/home/home_en.mp4": 1471,
	"./videos/home/home_jp.jpg": 1472,
	"./videos/home/home_jp.mp4": 1473,
	"./videos/ipad/3d/3d-export_cn.jpg": 1474,
	"./videos/ipad/3d/3d-export_cn.mp4": 1475,
	"./videos/ipad/3d/3d-export_cn.webm": 1476,
	"./videos/ipad/3d/3d-export_cn_hevc.mp4": 1477,
	"./videos/ipad/3d/3d-export_en.jpg": 1478,
	"./videos/ipad/3d/3d-export_en.mp4": 1479,
	"./videos/ipad/3d/3d-export_en.webm": 1480,
	"./videos/ipad/3d/3d-export_en_hevc.mp4": 1481,
	"./videos/ipad/3d/3d-export_jp.jpg": 1482,
	"./videos/ipad/3d/3d-export_jp.mp4": 1483,
	"./videos/ipad/3d/3d-export_jp.webm": 1484,
	"./videos/ipad/3d/3d-export_jp_hevc.mp4": 1485,
	"./videos/ipad/3d/3d-model_cn-hevc.mp4": 1486,
	"./videos/ipad/3d/3d-model_cn.jpg": 1487,
	"./videos/ipad/3d/3d-model_cn.mp4": 1488,
	"./videos/ipad/3d/3d-model_cn.webm": 1489,
	"./videos/ipad/3d/3d-model_en-hevc.mp4": 1490,
	"./videos/ipad/3d/3d-model_en.jpg": 1491,
	"./videos/ipad/3d/3d-model_en.mp4": 1492,
	"./videos/ipad/3d/3d-model_en.webm": 1493,
	"./videos/ipad/3d/3d-model_enBU.jpg": 1494,
	"./videos/ipad/3d/3d-model_jp-hevc.mp4": 1495,
	"./videos/ipad/3d/3d-model_jp.jpg": 1496,
	"./videos/ipad/3d/3d-model_jp.mp4": 1497,
	"./videos/ipad/3d/3d-model_jp.webm": 1498,
	"./videos/ipad/3d/3d-transform_cn.jpg": 1499,
	"./videos/ipad/3d/3d-transform_cn.mp4": 1500,
	"./videos/ipad/3d/3d-transform_en.jpg": 1501,
	"./videos/ipad/3d/3d-transform_en.mp4": 1502,
	"./videos/ipad/3d/3d-transform_jp.jpg": 1503,
	"./videos/ipad/3d/3d-transform_jp.mp4": 1504,
	"./videos/ipad/3d/3d_cn.jpg": 1505,
	"./videos/ipad/3d/3d_cn.mp4": 1506,
	"./videos/ipad/3d/3d_en.jpg": 1507,
	"./videos/ipad/3d/3d_en.mp4": 1508,
	"./videos/ipad/3d/3d_jp.jpg": 1509,
	"./videos/ipad/3d/3d_jp.mp4": 1510,
	"./videos/ipad/a11y/audio-feedback_en.jpg": 1511,
	"./videos/ipad/a11y/audio-feedback_en.mp4": 1512,
	"./videos/ipad/a11y/gestures_cn.jpg": 1513,
	"./videos/ipad/a11y/gestures_cn.mp4": 1514,
	"./videos/ipad/a11y/gestures_en.jpg": 1515,
	"./videos/ipad/a11y/gestures_en.mp4": 1516,
	"./videos/ipad/a11y/gestures_jp.jpg": 1517,
	"./videos/ipad/a11y/gestures_jp.mp4": 1518,
	"./videos/ipad/a11y/hero_en.jpg": 1519,
	"./videos/ipad/a11y/hero_en.mp4": 1520,
	"./videos/ipad/ada-cube.mp4": 1521,
	"./videos/ipad/color/color-drop_cn.jpg": 1522,
	"./videos/ipad/color/color-drop_cn.mp4": 1523,
	"./videos/ipad/color/color-drop_en.jpg": 1524,
	"./videos/ipad/color/color-drop_en.mp4": 1525,
	"./videos/ipad/color/color-drop_jp.jpg": 1526,
	"./videos/ipad/color/color-drop_jp.mp4": 1527,
	"./videos/ipad/color/color_cn.jpg": 1528,
	"./videos/ipad/color/color_cn.mp4": 1529,
	"./videos/ipad/color/color_en.jpg": 1530,
	"./videos/ipad/color/color_en.mp4": 1531,
	"./videos/ipad/color/color_jp.jpg": 1532,
	"./videos/ipad/color/color_jp.mp4": 1533,
	"./videos/ipad/color/gradient-map_cn.jpg": 1534,
	"./videos/ipad/color/gradient-map_cn.mp4": 1535,
	"./videos/ipad/color/gradient-map_en.jpg": 1536,
	"./videos/ipad/color/gradient-map_en.mp4": 1537,
	"./videos/ipad/color/gradient-map_jp.jpg": 1538,
	"./videos/ipad/color/gradient-map_jp.mp4": 1539,
	"./videos/ipad/cutting-edge/animationassist-cn.jpg": 1540,
	"./videos/ipad/cutting-edge/animationassist-cn.mp4": 1541,
	"./videos/ipad/cutting-edge/animationassist-en.jpg": 1542,
	"./videos/ipad/cutting-edge/animationassist-en.mp4": 1543,
	"./videos/ipad/cutting-edge/animationassist-jp.jpg": 1544,
	"./videos/ipad/cutting-edge/animationassist-jp.mp4": 1545,
	"./videos/ipad/cutting-edge/colordrop-cn.jpg": 1546,
	"./videos/ipad/cutting-edge/colordrop-cn.mp4": 1547,
	"./videos/ipad/cutting-edge/colordrop-en.jpg": 1548,
	"./videos/ipad/cutting-edge/colordrop-en.mp4": 1549,
	"./videos/ipad/cutting-edge/colordrop-jp.jpg": 1550,
	"./videos/ipad/cutting-edge/colordrop-jp.mp4": 1551,
	"./videos/ipad/cutting-edge/freehand-cn.jpg": 1552,
	"./videos/ipad/cutting-edge/freehand-cn.mp4": 1553,
	"./videos/ipad/cutting-edge/freehand-en.jpg": 1554,
	"./videos/ipad/cutting-edge/freehand-en.mp4": 1555,
	"./videos/ipad/cutting-edge/freehand-jp.jpg": 1556,
	"./videos/ipad/cutting-edge/freehand-jp.mp4": 1557,
	"./videos/ipad/cutting-edge/gestures_cn.jpg": 1558,
	"./videos/ipad/cutting-edge/gestures_cn.mp4": 1559,
	"./videos/ipad/cutting-edge/gestures_en.jpg": 1560,
	"./videos/ipad/cutting-edge/gestures_en.mp4": 1561,
	"./videos/ipad/cutting-edge/hero_cn.jpg": 1562,
	"./videos/ipad/cutting-edge/hero_cn.mp4": 1563,
	"./videos/ipad/cutting-edge/hero_en.jpg": 1564,
	"./videos/ipad/cutting-edge/hero_en.mp4": 1565,
	"./videos/ipad/cutting-edge/quickshape-cn.jpg": 1566,
	"./videos/ipad/cutting-edge/quickshape-cn.mp4": 1567,
	"./videos/ipad/cutting-edge/quickshape-en.jpg": 1568,
	"./videos/ipad/cutting-edge/quickshape-en.mp4": 1569,
	"./videos/ipad/cutting-edge/quickshape-jp.jpg": 1570,
	"./videos/ipad/cutting-edge/quickshape-jp.mp4": 1571,
	"./videos/ipad/filters_cn.jpg": 1572,
	"./videos/ipad/filters_cn.mp4": 1573,
	"./videos/ipad/filters_en.jpg": 1574,
	"./videos/ipad/filters_en.mp4": 1575,
	"./videos/ipad/hero_cn.jpg": 1576,
	"./videos/ipad/hero_cn.mp4": 1577,
	"./videos/ipad/hero_en.jpg": 1578,
	"./videos/ipad/hero_en.mp4": 1579,
	"./videos/ipad/hero_jp.jpg": 1580,
	"./videos/ipad/hero_jp.mp4": 1581,
	"./videos/ipad/timelapse-video-asuka-poster.jpg": 1582,
	"./videos/ipad/timelapse-video-asuka.mp4": 1583,
	"./videos/ipad/video/animation-video-alexgrigg-poster.jpg": 1584,
	"./videos/ipad/video/animation-video-alexgrigg.mp4": 1585,
	"./videos/ipad/video/timelapse-video-max-poster.jpg": 1586,
	"./videos/ipad/video/timelapse-video-max.mp4": 1587,
	"./videos/ipad/whats-new/3d-painting_cn.jpg": 1588,
	"./videos/ipad/whats-new/3d-painting_cn.mp4": 1589,
	"./videos/ipad/whats-new/3d-painting_en.jpg": 1590,
	"./videos/ipad/whats-new/3d-painting_en.mp4": 1591,
	"./videos/ipad/whats-new/3d-painting_jp.jpg": 1592,
	"./videos/ipad/whats-new/3d-painting_jp.mp4": 1593,
	"./videos/ipad/whats-new/whats-new_cn.jpg": 1594,
	"./videos/ipad/whats-new/whats-new_cn.mp4": 1595,
	"./videos/ipad/whats-new/whats-new_en.jpg": 1596,
	"./videos/ipad/whats-new/whats-new_en.mp4": 1597,
	"./videos/ipad/whats-new/whats-new_jp.jpg": 1598,
	"./videos/ipad/whats-new/whats-new_jp.mp4": 1599,
	"./videos/pocket/cn_animate.mp4": 1600,
	"./videos/pocket/en_animate.mp4": 1601,
	"./videos/pocket/jp_animate.mp4": 1602,
	"./videos/pocket/timelapse_desktop.mp4": 1603,
	"./videos/pocket/timelapse_desktop_poster.jpg": 1604,
	"./videos/pocket/timelapse_mobile.mp4": 1605,
	"./videos/pocket/timelapse_mobile_poster.jpg": 1606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1452;